export default {
	entgratart: {
		notEntgraten: "Ne pas ébavurer",
		manually: "Manuel",
		oneSided: "Unilatéral (dessous)",
		trowalisieren: "Tribofinition",
		bothSides: "Des deux côtés",
		undefinedState: "Indéfini",
		notAvailable: "Non disponible",
	},
	priceModel: {
		standard: "Rapide",
		slow: "Économique",
		express: "Express",
	},
	zincCoating: {
		none: "Non",
		hotDip: "Galvanisé à chaud",
		galvanize: "Galvanisé électrolytique",
		both: "Les deux",
	},
	complainType: {
		outOfTolerance: "Dimensions hors tolérance",
		wrongBending: "Pliage défectueux",
		cutQualityLow: "Qualité de coupe insatisfaisante",
		scratches: "Surface excessivement rayée",
		missingCuts: "Découpes manquantes",
		wrongGrainDirection: "Sens du fil incorrect",
		transportDamage: "Dommage de transport",
		missing: "Pièces manquantes à la livraison",
		powderCoating: "Thermolaquage défectueux",
		weldline: "Cordon de soudure défectueux",
		feature: "Filetage, fraisage ou emboutissage défectueux",
		other: "Autre réclamation",
		zincCoating: "Galvanisation défectueuse",
		wrongOrMissingPressJoin: "Sertissage manquant ou non conforme à la commande",
	},
	complaintExpectationType: {
		ersatzlieferung: "Livraison de remplacement",
		other: "Autre attente...",
	},
};
